// External modules
import { action } from 'easy-peasy';

// Internal modules
import { $logger } from '@/lib/logger';
import { apiModelFactory, getApiState } from './api';
import { AUTO_COMPLETE_TYPE, formModelFactory, getFormState } from './form';
import { getUiState, uiModelFactory } from './ui';
import { getUserState, userModelFactory } from './user';

const getInitialStoreState = ({ api, form, ui, user } = {}) => ({
  api: getApiState(api),
  form: getFormState(form),
  ui: getUiState(ui),
  user: getUserState(user),
});

const storeModel = {
  api: apiModelFactory(),
  form: formModelFactory(),
  ui: uiModelFactory(),
  user: userModelFactory(),

  // eslint-disable-next-line sort-keys
  resetStore: action((state, overrides) => {
    $logger.info('reset_app_store');
    return getInitialStoreState(overrides);
  }),
};

export { storeModel, AUTO_COMPLETE_TYPE };
export * from './utils';
